<template>
    <form-view class="user-account-view" @submitsuccess="resetState">
        <template slot="field">
            <veui-field label="用户名：" name="userName" field="userName" rules="required">
                <veui-input v-model="store.formData.userName" :readonly="!editable"/>
            </veui-field>
            <veui-field label="联系人姓名："
                name="contact"
                field="contact"
                :rules="validator('required|name|maxLength:20=名称长度不得超过20个字符')">
                <veui-input v-model="store.formData.contact" :readonly="!editable"/>
            </veui-field>
            <veui-field label="联系人邮箱：" name="email" field="email" :rules="validator('required|email')">
                <veui-input v-model="store.formData.email" :readonly="!editable"/>
            </veui-field>
            <veui-field label="联系人电话：" name="phone" field="phone" :rules="validator('required|mobile')" ref="phone">
                <veui-input v-model="store.formData.phone" :readonly="!editable"/>
                <veui-button :disabled="waitSecond != null" v-show="editable" @click="sendSMSCode">{{ sendSmsCodeBtnText }}</veui-button>
            </veui-field>
            <veui-field name="transId" field="transId" class="hidden-field"/>
            <veui-field
                label="短信验证码："
                v-if="editable"
                :rules="validator('required|pattern:\\d{4}=请填写有效验证码')"
                name="smscode"
                field="smscode">
                <veui-input v-model="store.formData.smscode" :readonly="!editable"/>
            </veui-field>
             <veui-field label="账号密码：" v-if="hasAuth">
                 <veui-span><router-link to="/user/password/edit">修改密码&gt;&gt;</router-link></veui-span>
             </veui-field>
        </template>

        <template slot="operation">
            <veui-button ui="primary" :disabled="!hasAuth" v-if="!editable" @click="editable = true">修改</veui-button>
            <template v-else>
                <veui-button ui="primary" type="submit">提交</veui-button>
                <veui-button ui="aux" @click="editable = false">取消</veui-button>
            </template>
        </template>
    </form-view>
</template>

<script>
import FormView from '@baidu/ve-ria/views/FormView';
import FormModel from './FormModel';
import createView from '@baidu/ve-ria/views/createView';
import {Field, Button, Input, Span} from 'veui';

export default createView(FormView, FormModel, {
    name: 'AccountView',
    components: {
        'veui-field': Field,
        'veui-input': Input,
        'veui-span': Span,
        'veui-button': Button
    },
    data() {
        return {
            editable: false,
            timer: null,
            waitSecond: null
        };
    },
    computed: {
        sendSmsCodeBtnText() {
            return this.waitSecond == null ? '发送验证码' : `${this.waitSecond}s`;
        },
        hasAuth() {
            if (this.$route.meta.isAdmin) {
                return this.isAllow('rton:auth.admin.system.user');
            }
            return this.isAllow('rton:auth.client.user');
        }
    },
    methods: {
        async sendSMSCode() {
            let result = this.$refs.phone.validate();
            if (result !== true) {
                return;
            }
            this.waitSecond = 60;
            if (this.timer) {
                clearInterval(this.timer);
            }
            // TODO localStorage 存一下
            await this.store.sendSMSCode(this.store.formData.phone);
            this.timer = setInterval(() => {
                if (--this.waitSecond) {
                    return;
                }
                clearInterval(this.timer);

                // 让 0s 显示出现
                setTimeout(() => this.waitSecond = null, 100);
            }, 1000);
        },
        resetState() {
            this.editable = false;
            this.waitSecond = null;
            this.store.formData.transId = '';
            this.store.formData.smscode = '';
        }
    },
    beforeDestroy() {
        clearInterval(this.timer);
    }
});
</script>
